module.exports = __webpack_public_path__ + "img/resized-APP-0022-1.117f361a.png";